var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSamstag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 288 108",
    style: {
      enableBackground: "new 0 0 288 108"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:white;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M277.3,47.1C275.8,46,254.5,30,254.5,30l-7.4,5.4c0,0,21.4,16,22.7,17.1c1.4,1.1,1.4,1.1,1.4,3.3 c0,2.1-0.2,21.9-0.2,21.9l7.5-5.5c0,0,0.2-19.8,0.2-21.9C278.7,48.2,278.7,48.2,277.3,47.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M284.5,40.7c-0.6-0.4-17.9-13.8-19.6-14.9c-1.9-1.3-3.5-0.9-4.8,0.1c-2.2,1.6-4,3-4,3l23.8,17.8l6.3-4.6 C286.1,42,285.2,41.1,284.5,40.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M263.1,58.8c0.6-0.4,6-4.3,6-4.3l-23.7-17.8c0,0-4,2.9-5.1,3.7c-1.1,0.8-1.7,1.6-1.7,1.6s22.8,16.5,23.3,16.8 C262.5,59.2,262.5,59.2,263.1,58.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M262,60.5c-0.5-0.4-24-17.5-24-17.5s-0.3,0.7-0.3,1.7c0,1,0,16.1,0,18.4c0,2.4,1.4,3.5,1.4,3.5 s18.9,14.2,20.8,15.5c1.8,1.3,3.4,1.3,5.2,0c0.9-0.6,4.4-3.2,4.4-3.2l0-4.4c0,0-5.1,3.8-5.9,4.2c-0.7,0.5-1.4,0.4-2-0.1 c-0.8-0.6-18.2-13.5-19-14.1c-0.8-0.6-1-1.1-1-2.3c0-1.2,0-10.8,0-10.8s-0.2-1.6,1.1-0.5c1.3,1,18.5,13.5,19,13.9 c0.6,0.4,1.3,0.5,2,0c0.6-0.5,6-4.5,6-4.5l0-4.6c0,0-6,4.3-6.5,4.7C262.5,60.9,262.5,60.9,262,60.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M287.1,45c0-1.3-0.3-1.8-0.3-1.8l-6.4,4.8l-0.1,4.7c0,0,1-0.8,2.2-1.8c1.3-1,1.1,0.5,1.1,0.5s0,9.5,0,10.7 c0,1.2,0.1,1.8-0.7,2.5c-0.8,0.7-2.7,2.1-2.7,2.1l-0.1,4.4c0,0,4.8-3.5,5.3-4c0.5-0.5,1.5-1.6,1.6-3.8c0-1.4,0.1-8.9,0.1-13.9v-0.3 v-0.3v-0.3v-0.3v-0.3v-0.3L287.1,45z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M20.8,52.1H8.8c-1,0-1.7-0.3-2.3-0.8c-0.5-0.4-0.7-1-0.7-1.7C5.7,49,6,48.5,6.5,48c0.5-0.5,1.3-0.7,2.2-0.7H28 v-4.2H8.8c-2.5,0-4.5,0.7-6,2.1c-1.3,1.2-2,2.7-2,4.5c0,1.8,0.7,3.3,2,4.6c1.5,1.4,3.4,2.1,6,2.1h12.1c1.5,0,2.7,0.3,3.5,1 c0.8,0.6,1.2,1.3,1.2,2.2c0,0.9-0.4,1.7-1.2,2.3c-0.9,0.7-2,1-3.5,1H1.4V67h19.4c2.8,0,4.9-0.8,6.6-2.3c1.4-1.4,2.2-3.1,2.2-5.1 c0-2-0.7-3.7-2.2-5.2C25.7,52.9,23.5,52.1,20.8,52.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M48.7,43.5C48,43.1,47.5,43,46.9,43c-0.5,0-1,0.2-1.6,0.6c-0.7,0.4-1.3,1-1.7,1.7L29.7,67h5.7L47,49.2l4.4,6.9 h-6.7l-2.7,4.2H54l4.3,6.7h5.7L50.5,45.3C50,44.6,49.4,44,48.7,43.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M98.6,42.8c-1-0.1-2,0.7-2.9,2.3l-8.5,15.7l-8.5-15.6c-0.9-1.7-1.9-2.4-2.9-2.4c-1.4,0.1-2.3,0.9-2.7,2.4 l-5.7,21.9h5l3.7-16.8l8.5,15.4c0.6,1.1,1.5,1.6,2.6,1.6c1,0,1.8-0.5,2.4-1.6l8.5-15.4l3.7,16.8h5l-5.7-22 C100.8,43.6,99.9,42.9,98.6,42.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M129.6,52.1h-12c-1,0-1.7-0.3-2.3-0.8c-0.5-0.4-0.7-1-0.7-1.7c0-0.7,0.3-1.2,0.8-1.7c0.5-0.5,1.3-0.7,2.2-0.7 h19.2v-4.2h-19.2c-2.5,0-4.5,0.7-6,2.1c-1.3,1.2-2,2.7-2,4.5c0,1.8,0.7,3.3,2,4.6c1.5,1.4,3.5,2.1,6,2.1h12c1.5,0,2.7,0.3,3.5,1 c0.8,0.6,1.2,1.3,1.2,2.2c0,0.9-0.4,1.7-1.2,2.3c-0.9,0.7-2,1-3.5,1h-19.4V67h19.4c2.8,0,5-0.8,6.6-2.3c1.4-1.4,2.2-3.1,2.2-5.1 c0-2-0.7-3.7-2.2-5.2C134.5,52.9,132.3,52.1,129.6,52.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "164.5,43.1 140,43.1 140,47.2 150.1,47.2 150.1,67 154.5,67 154.5,47.2 164.5,47.2  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M180.7,43.5c-0.6-0.4-1.2-0.5-1.7-0.5c-0.5,0-1,0.2-1.6,0.6c-0.7,0.4-1.3,1-1.7,1.7L161.8,67h5.7L179,49.2 l4.4,6.9h-6.7l-2.7,4.2h12.1l4.3,6.7h5.7l-13.5-21.6C182.1,44.6,181.5,44,180.7,43.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M208.3,53.8v3.8h12.1v5.2h-11.7c-2.7,0-4.9-0.8-6.5-2.5c-1.4-1.5-2.1-3.3-2-5.5c0.1-2.1,0.8-3.8,2.2-5.2 c1.6-1.6,3.7-2.4,6.2-2.4H223v-4.2h-14.4c-4.1,0-7.3,1.2-9.7,3.7c-2.1,2.2-3.1,4.8-3.1,8c0,3.3,1.1,6.1,3.3,8.4 c2.4,2.6,5.6,3.8,9.6,3.8h16.2V53.8H208.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSamstag);
export default __webpack_public_path__ + "static/media/samstag.aea7cf331e20ee87da765743691e1d58.svg";
export { ForwardRef as ReactComponent };